import React, { useState, useEffect, useRef } from 'react';
import './Testimonials.css';

const ALL_CARDS = [
  {
    stars: 5,
    text: 'Ordered my Air Force 1s on a Friday and they were at my door by Monday. Packaging was clean, shoes were legit. SA Dropped is the real deal.',
    name: 'Yusuf Essop',
    role: 'Cape Town',
    img: '/images/usersa.png',
  },
  {
    stars: 5,
    text: 'Finally a SA sneaker store that actually knows what they are doing. Got my Sambas verified and delivered with no stress. Will not shop anywhere else.',
    name: 'Thabo Mokoena',
    role: 'Johannesburg',
    img: '/images/usersa.png',
  },
  {
    stars: 5,
    text: 'The customer service is unmatched. Had a question about sizing and they responded within minutes. Shoes arrived perfect. Highly recommend.',
    name: 'Fatima Cassim',
    role: 'Durban',
    img: '/images/usersa.png',
  },
  {
    stars: 5,
    text: 'I was sceptical at first buying sneakers online but SA Dropped proved me wrong. Authentic pair, great price, fast delivery to Pretoria.',
    name: 'Sipho Ndlovu',
    role: 'Pretoria',
    img: '/images/usersa.png',
  },
  {
    stars: 5,
    text: 'Got the Dunk Lows I have been hunting for months. SA Dropped had them in my size when nobody else did. Absolute legends.',
    name: 'Aamir Saloojee',
    role: 'Lenasia',
    img: '/images/usersa.png',
  },
  {
    stars: 5,
    text: 'Clean website, easy checkout, fast shipping. The Yeezys I ordered are 100% authentic — I checked everything. SA Dropped is locked in.',
    name: 'Naledi Dlamini',
    role: 'Soweto',
    img: '/images/usersa.png',
  },
  {
    stars: 5,
    text: 'Bought a pair for my son and he has not taken them off since. The quality is exactly as described. Will definitely be ordering again.',
    name: 'Zainab Variawa',
    role: 'Port Elizabeth',
    img: '/images/usersa.png',
  },
  {
    stars: 5,
    text: 'SA Dropped came through with the limited colourway I thought I had no chance of getting. Delivery was fast and the box was pristine.',
    name: 'Kagiso Sithole',
    role: 'Sandton',
    img: '/images/usersa.png',
  },
  {
    stars: 5,
    text: 'Best sneaker plug in the country no debate. Authentic, affordable and they actually care about their customers. Big up SA Dropped.',
    name: 'Ridwaan Petersen',
    role: 'Mitchell\'s Plain',
    img: '/images/usersa.png',
  },
];

const PAGES = [
  ALL_CARDS.slice(0, 3),
  ALL_CARDS.slice(3, 6),
  ALL_CARDS.slice(6, 9),
];

export default function Testimonials() {
  const [page, setPage]       = useState(0);
  const [fading, setFading]   = useState(false);
  const pausedRef             = useRef(false);

  const goTo = (idx) => {
    if (idx === page || fading) return;
    setFading(true);
    setTimeout(() => {
      setPage(idx);
      setFading(false);
    }, 300);
  };

  const advance = () => {
    if (pausedRef.current) return;
    setFading(true);
    setTimeout(() => {
      setPage(p => (p + 1) % PAGES.length);
      setFading(false);
    }, 300);
  };

  useEffect(() => {
    const t = setInterval(advance, 3000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="testi">
      <div className="testi__header">
        <p className="testi__eyebrow">W h a t &nbsp; T h e y &nbsp; S a y</p>
        <h2 className="testi__title">TESTIMONIALS</h2>
      </div>

      <div className={`testi__grid${fading ? ' testi__grid--fade' : ''}`}>
        {PAGES[page].map((c, i) => (
          <article
            key={`${page}-${i}`}
            className="testi-card"
            onMouseEnter={() => { pausedRef.current = true; }}
            onMouseLeave={() => { pausedRef.current = false; }}
          >
            <div className="testi-card__top">
              <div className="testi-card__stars">{'★'.repeat(c.stars)}</div>
              <span className="testi-card__quote">"</span>
            </div>
            <p className="testi-card__text">{c.text}</p>
            <div className="testi-card__person">
              <img
                src={c.img}
                alt={c.name}
                className="testi-card__avatar"
              />
              <div className="testi-card__meta">
                <strong>{c.name}</strong>
                <span>{c.role}</span>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="testi__dots">
        {PAGES.map((_, i) => (
          <button
            key={i}
            className={`testi__dot${i === page ? ' testi__dot--on' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Page ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}